import React from 'react';
import { Result, Button, Typography } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const { Text } = Typography;

interface ServerStatusProps {
  retryIn: number;
  onRetryNow: () => void;
}

const ServerStatus: React.FC<ServerStatusProps> = ({ retryIn, onRetryNow }) => {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Result
        status="500"
        title="Server Unavailable"
        subTitle="We're having trouble connecting to the server. Retrying automatically..."
        extra={[
          <Text key="timer" type="secondary" style={{ display: 'block', marginBottom: 16 }}>
            <LoadingOutlined style={{ marginRight: 8 }} />
            Next retry in {retryIn}s
          </Text>,
          <Button key="retry" type="primary" style={{ backgroundColor: "#4f46e5" }} onClick={onRetryNow}>
            Retry Now
          </Button>,
        ]}
      />
    </div>
  );
};

export default ServerStatus;